import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Table from './Table'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

function BannerManager () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'banner-management') ?? {}
  const [allBanner, setAllBanner] = useState([])
  const [page] = useState(1)
  const [items, setItem] = useState('')
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const getBanner = async () => {
    try {
      const payload = {
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.getBanner
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        setAllBanner(response)
      }
    } catch (error) {
      console.log('error ', error)
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handelEdit = item => {
    setItem(items)
    navigate('/banner_manager/edit', { state: item })
  }
  useEffect(() => {
    getBanner()
  }, [page, sort])

  useEffect(() => {
    updatePageName(t('BANNER_MANAGER'))
  }, [])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
              <div className='flex mt-2 justify-end mr-2'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    title={t('ADD_BANNER')}
                    type='button'
                    className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    disabled={allBanner.bannerLength >= 5}
                    onClick={() => navigate('/banner_manager/add')}
                  >
                    + {t('ADD_BANNER')}
                  </button>
                )}
              </div>
            </div>
            <Table
              allBanner={allBanner}
              user={user}
              getBanner={getBanner}
              handelEdit={handelEdit}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default BannerManager
